import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function PrivacyHistory({ refreshKey }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/admin/legal/privacy/history").then((r) => setItems(r.data)).catch(() => setItems([])); }, [refreshKey]);
  const fmt = (d) => (d ? new Date(d).toLocaleString() : "—");
  return (
    <section className="mt-10" data-testid="privacy-history">
      <h2 className="label flex items-center gap-2"><Lock size={12} /> Version archive (read-only) · {items.length}</h2>
      {items.length === 0 && <p className="text-sm text-[var(--muted)]">Previous versions appear here automatically each time a changed Privacy policy is saved.</p>}
      <ul className="divide-y divide-[var(--line)] border border-[var(--line)]">
        {items.map((h) => (
          <li key={h.version} data-testid={`privacy-history-${h.version}`}>
            <button type="button" onClick={() => setOpen(open === h.version ? null : h.version)} className="w-full flex items-center gap-4 px-4 py-3 text-left text-sm hover:bg-[var(--surface)]" data-testid={`privacy-history-toggle-${h.version}`}>
              <span className="font-bold w-10">v{h.version}</span>
              <span className="flex-1 text-xs text-[var(--muted)]">valid {fmt(h.valid_from)} → {fmt(h.valid_until)}{h.saved_by ? ` · saved by ${h.saved_by}` : ""} · languages: {Object.keys(h.content).filter((k) => h.content[k]?.trim()).join(", ").toUpperCase() || "—"}</span>
              {open === h.version ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
            {open === h.version && (
              <div className="px-4 pb-4 space-y-4" data-testid={`privacy-history-content-${h.version}`}>
                {Object.entries(h.content).filter(([, v]) => v?.trim()).map(([code, text]) => (
                  <div key={code}>
                    <p className="label">{code}</p>
                    <pre className="whitespace-pre-wrap font-sans text-sm text-[#d8d8d8] bg-[var(--surface)] p-4 border border-[var(--line)]">{text}</pre>
                  </div>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
